class HubeiQunyiguanMap1 {
  constructor(opt) {
    this.timmer = opt.timmer
    this.cityTimmer = opt.cityTimmer
    this.content = opt.content
    this.cityNames = null
    this.hubei = null
    this.formatterData = null
    this.preventCity = []
  }
  /**
   *
   * @param {Ojbect} content //该参数为组件上下文的this指向
   */
  dispatchLoopSelectAction(formatterData) {
    this.formatterData = formatterData
    //在更新地图组件数据的时候，会再次执行插件，因此需要清除上次执行时的timmer
    if (this.timmer) {
      clearInterval(this.timmer)
      this.timmer = null
      this.cityTimmer = -1 //-1表示从湖北省的框开始
    }
    this.timmer = setInterval(() => {
      if (this.content.$refs.map.dispatchAction) {
        if (this.cityTimmer === -1) {
          // 触发湖北省的提示框
          this.content.$refs.map.dispatchAction({
            type: "geoUnSelect",
            name: this.cityNames[this.cityNames.length - 1]
          })
          this.createSelectDom()
          this.cityTimmer = this.cityTimmer === this.cityNames.length - 1 ? -1 : this.cityTimmer + 1
        } else {
          //触发市级select效果
          let name = this.cityNames[this.cityTimmer]
          let addBefore = false
          while (this.preventCity.find(it => it === name)) {
            addBefore = true
            name = this.cityNames[this.cityTimmer + 1]
            //递增触发select的城市的名称数组的数组下标
            this.cityTimmer = this.cityTimmer === this.cityNames.length - 1 ? -1 : this.cityTimmer + 1
          }
          this.content.$refs.map.dispatchAction({
            type: "geoSelect",
            name
          })
          //生成select提示框dom
          this.createSelectDom()
          if (!addBefore) {
            //递增触发select的城市的名称数组的数组下标
            this.cityTimmer = this.cityTimmer === this.cityNames.length - 1 ? -1 : this.cityTimmer + 1
          }
        }
      }
    }, 3000)
  }
  createSelectDom() {
    //清除上一次的提示框
    if (this.content.$refs.chartBox.getElementsByClassName("HubeiQunyiguanMap1").length) {
      this.content.$refs.chartBox.removeChild(
        this.content.$refs.chartBox.getElementsByClassName("HubeiQunyiguanMap1")[0]
      )
    }
    const el = this.content.$refs.chartBox
    el.style.position = "relative"
    const elWidth = el.offsetWidth
    let selectBox = document.createElement("div")
    selectBox = this.createStyle(selectBox, {
      width: elWidth * 0.195 + "px",
      border: "1px solid rgb(41,154,247)",
      borderRadius: "4px",
      backgroundColor: "rgb(8,14,75)",
      position: "absolute",
      right: "20px",
      top: "20px"
    })
    selectBox.className = "HubeiQunyiguanMap1"

    selectBox.innerHTML = this.getFormatStr(
      this.cityTimmer === -1 ? "湖北省群众艺术馆" : this.cityNames[this.cityTimmer]
    )

    el.appendChild(selectBox)
  }
  createStyle(dom, style) {
    Object.keys(style).forEach(styleName => {
      dom.style[styleName] = style[styleName]
    })
    return dom
  }
  getFormatStr(params) {
    const bottomTitleStyle = "font-size: 14px;font-weight: 400;line-height: 24px;color:#FFFFFF"
    const bottomValueStyle = "font-size: 16px;font-weight: 700;line-height: 24px;color:#FFFF00"
    let content = undefined
    const staticData = [
      { key: "活动", value: "1232场" },
      { key: "资讯", value: "354条" },
      { key: "直播", value: "34时" }
    ]
    if (this.formatterData && this.formatterData.length) {
      const obj = this.formatterData.find(item => item.name.includes(params))
      if (obj) {
        content = obj.data
      } else {
        content = staticData
      }
    } else {
      content = staticData
    }
    function getAllContent() {
      let res = ""
      content.forEach(item => {
        res +=
          "<p style='margin-top:17px;" +
          bottomTitleStyle +
          "'>" +
          item.key +
          "  " +
          "<span style='" +
          bottomValueStyle +
          "'>" +
          item.value.slice(0, -1) +
          "</span>" +
          " " +
          item.value.slice(-1) +
          ""
      })
      return res
    }
    return (
      "<p style='padding:0 20px;width:100%;text-align:center;font-size: 16px;fontWeight:700;color: #ffffff;background: linear-gradient(0deg,#0bbafb 0%, #4285ec 100%);line-height: 30px;'>" +
      params +
      "</p>" +
      "<div style='padding:0 10px 10px 10px'>" +
      getAllContent() +
      "</div>"
    )
  }
  clickCity = param => {
    if (!param.name.length) return
    if (param.hasOwnProperty("componentSubType")) {
      //点击房子效果
      this.content.$refs.map.dispatchAction({
        type: "geoUnSelect",
        name: this.cityNames[this.cityTimmer]
      })
      this.cityTimmer = -1
      this.createSelectDom()
    } else {
      let timmer = this.cityNames.findIndex(it => it === param.name)
      if (this.preventCity.find(it => it === param.name)) {
        //不能点击不显示的位置
        this.content.$refs.map.dispatchAction({
          type: "geoSelect",
          name: this.cityNames[this.cityTimmer - 1]
        })
        return
      }
      if (this.cityTimmer - 1 === timmer) {
        //如果当前手动点击的城市和当前自动轮播模拟点击到的城市的是同一个城市，则再次激活当前手动点击的城市
        //因为 如果当前手动点击的城市===当前自动轮播点击到的城市 的话，前自动轮播点击到的城市的选中状态会消失
        this.content.$refs.map.dispatchAction({
          type: "geoSelect",
          name: this.cityNames[timmer]
        })
      }
      this.cityTimmer = timmer
      this.createSelectDom()
    }
  }
}
export default {
  data() {
    return {
      HubeiQunyiguanMap1: new HubeiQunyiguanMap1({
        timmer: null,
        cityTimmer: -1, //-1表示从湖北省的框开始
        content: this
      })
    }
  },
  methods: {
    async hubeiQunYiGuanMap1Plugin(opt, echarts, url) {
      const hubeiChartOpt = opt.chartOption
      //注册地图

      //此处开始定制地图的逻辑书写
      hubeiChartOpt.series = []
      const getMapJson = this.instance.get("sv2/assets/湖北省.420000.json")
      let getHuBeiData = null
      if (opt.restDataUrl.length) {
        getHuBeiData = this.instance.get(opt.restDataUrl)
      } else {
        getHuBeiData = Promise.resolve()
      }
      //等待数据获取完成后开始书写逻辑
      Promise.all([getMapJson, getHuBeiData]).then(values => {
        const _self = this
        let [mapJson, formatterData] = values
        mapJson = mapJson.data
        echarts.registerMap("hubei", mapJson)
        this.HubeiQunyiguanMap1.hubei = mapJson
        this.HubeiQunyiguanMap1.cityNames = mapJson.features.map(it => it.properties.name)
        formatterData = this.hasProperty(formatterData, "data.data.content.data") || formatterData
        const itemStyle = {
          areaColor: {
            type: "linear",
            x: 0.1,
            y: 0.1,
            x2: 0.1,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#073F75" // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#1586F5" // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          },
          borderColor: "#2085C2",
          borderWidth: 2,
          shadowColor: "#09307D",
          shadowBlur: 10,
          shadowOffsetX: 5,
          shadowOffsetY: 5
        }
        const emphasis = {
          itemStyle: {
            areaColor: {
              type: "linear",
              x: 0.1,
              y: 0.1,
              x2: 0.1,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "#E33E3E" // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#C11111" // 100% 处的颜色
                }
              ],
              global: false // 缺省为 false
            }
          },
          label: {
            show: false
          }
        }
        const select = {
          itemStyle: {
            areaColor: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "#D94141" // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#B90808" // 100% 处的颜色
                }
              ],
              global: false // 缺省为 false
            }
          },
          label: {
            show: false
          }
        }
        const getData = () => {
          const allCity = this.HubeiQunyiguanMap1.hubei.features
          const centerCode = [114.298572, 30.584355]
          const geoCoord = allCity
            .map(it => {
              if (this.HubeiQunyiguanMap1.preventCity.find(name => name === it.properties.name)) {
                return undefined
              } else {
                return [
                  {
                    value: 0,
                    coord: it.properties.center.map((it, ind) => {
                      const res = it
                      if (!ind) res + 3
                      return res
                    })
                  },
                  { coord: centerCode }
                ]
              }
            })
            .filter(it => it !== undefined)
          return geoCoord
        }
        const getPointData = () => {
          return this.HubeiQunyiguanMap1.hubei.features
            .map(item => {
              if (this.HubeiQunyiguanMap1.preventCity.find(it => it === item.properties.name)) {
                return undefined
              } else {
                return {
                  name: item.properties.name,
                  value: item.properties.center.concat(0)
                }
              }
            })
            .filter(it => it !== undefined)
        }
        hubeiChartOpt.tooltip = {}

        hubeiChartOpt.geo = {
          selectedMode: "single",
          map: "hubei",
          tooltip: {
            show: false
          }
        }
        hubeiChartOpt.geo.itemStyle = itemStyle
        hubeiChartOpt.geo.zlevel = 2
        hubeiChartOpt.geo.emphasis = emphasis
        hubeiChartOpt.geo.select = select
        // const hubeiValue = this.HubeiQunyiguanMap1.hubei.features[0].properties.center.concat([10])
        const hubeiValue = this.HubeiQunyiguanMap1.hubei.features[0].properties.center.concat([10])
        console.log("hubeiValue :>> ", hubeiValue)
        hubeiChartOpt.series.push(
          {
            type: "lines",
            zlevel: 2,
            animationDuration: 1000,
            effect: {
              show: true,
              period: 4, //箭头指向速度，值越小速度越快
              trailLength: 0.02, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: "arrow", //箭头图标
              symbolSize: 5 //图标大小
            },
            lineStyle: {
              color: "#39CBE8",
              type: [5, 5],
              dashOffset: 5,
              // normal: {
              width: 1.8, //尾迹线条宽度
              opacity: 1, //尾迹线条透明度
              curveness: 0.3 //尾迹线条曲直度
              // }
            },
            data: getData()
          },
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 3,
            animationDuration: 1000,
            rippleEffect: {
              //涟漪特效
              color: "white",
              number: 2,
              period: 4, //动画时间，值越小速度越快
              brushType: "stroke", //波纹绘制方式 stroke, fill
              scale: 4 //波纹圆环最大限制，值越大波纹越大
            },
            label: {
              show: true,
              position: "bottom", //显示位置
              color: "white", //文字颜色
              fontWeight: 500,
              fontFamily: "Source Han Sans CN",
              offset: [5, 0], //偏移设置
              formatter: "{b}",
              fontSize: 13
            },
            symbol: "circle",
            symbolSize: function (val) {
              return 5 + val[2] * 5 //圆环大小
            },
            itemStyle: {
              normal: {
                show: false,
                color: "white"
              }
            },
            data: getPointData()
          },
          //被攻击点
          {
            type: "scatter",
            coordinateSystem: "geo",
            zlevel: 2,
            animationDuration: 1000,
            //   rippleEffect: {
            //     period: 4,
            //     brushType: "stroke",
            //     scale: 4
            //   },
            symbol: "image:///sv2/assets/image/center.png",
            symbolSize: 60,
            data: [
              {
                name: "武汉市群艺馆",
                value: hubeiValue
              }
            ]
          }
        )
        //此处结束书写逻辑
        // ------------------------------------------
        //定制的定时触发echarts的select逻辑
        this.HubeiQunyiguanMap1.dispatchLoopSelectAction(formatterData)
        // this.reloadChart()
        // 更新完以后手动重新渲染echarts
      })
    }
  },
  beforeUpdate() {
    if (!this.options.chartOption.pluginName.find(it => it === "hubeiQunYiGuanMap1Plugin")) {
      clearInterval(this.HubeiQunyiguanMap1.timmer)
    }
  },
  beforeDestroy() {
    clearInterval(this.HubeiQunyiguanMap1.timmer)
  }
}
